/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CapannoneCreateDTO
 */
export interface CapannoneCreateDTO {
    /**
     * 
     * @type {number}
     * @memberof CapannoneCreateDTO
     */
    numero?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CapannoneCreateDTO
     */
    superficie?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CapannoneCreateDTO
     */
    doppioSilos?: boolean;
}

/**
 * Check if a given object implements the CapannoneCreateDTO interface.
 */
export function instanceOfCapannoneCreateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CapannoneCreateDTOFromJSON(json: any): CapannoneCreateDTO {
    return CapannoneCreateDTOFromJSONTyped(json, false);
}

export function CapannoneCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CapannoneCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'numero': !exists(json, 'numero') ? undefined : json['numero'],
        'superficie': !exists(json, 'superficie') ? undefined : json['superficie'],
        'doppioSilos': !exists(json, 'doppioSilos') ? undefined : json['doppioSilos'],
    };
}

export function CapannoneCreateDTOToJSON(value?: CapannoneCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'numero': value.numero,
        'superficie': value.superficie,
        'doppioSilos': value.doppioSilos,
    };
}

